import React from "react";
import styles from "./Header.module.css";
import Logo from "@/components/common/logo/Logo";
import type { headerProps } from "./types.props";

const Header: React.FC<headerProps> = ({
    logoLink = "/",
    logo = true,
    leftContent,
    centerContent,
    rightContent,
    variant = "default",
}) => {
    return (
        <header className={`${styles.header} ${styles[variant]}`}>
            <div className={styles.left}>
                {logo && <Logo to={logoLink} className={styles.logo} />}
                {leftContent}
            </div>
            {centerContent && <div className={styles.center}>{centerContent}</div>}
            {rightContent && <div className={styles.right}>{rightContent}</div>}
        </header>
    );
};

export default Header;
